import { useState } from 'react';
import { useAuth } from '../../context/AuthContext'; // dodaj import AuthContext

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user } = useAuth(); // proveravamo da li je korisnik ulogovan

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Find Providers', path: '/vendors' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  // Odredi putanju za ikonicu korisnika
  const userPath = user ? '/my-account' : '/auth';

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <a href="/" className="flex items-center cursor-pointer">
            <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center">
              <i className="ri-heart-pulse-fill text-white text-2xl"></i>
            </div>
            <span className="ml-3 text-xl font-bold text-gray-900">Revulist</span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.path}
                href={link.path}
                className="text-gray-700 hover:text-teal-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.name}
              </a>
            ))}
          </div>

          {/* Auth & Add Listing Buttons */}
          <div className="hidden md:flex items-center space-x-3">
            <a
              href="/pricing"
              className="inline-flex items-center justify-center px-5 py-2.5 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors font-medium cursor-pointer whitespace-nowrap"
            >
              Add a Listing
            </a>
            <a
              href={userPath}
              className="w-10 h-10 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer"
              title={user ? 'My Account' : 'Sign In / Sign Up'}
            >
              <i className="ri-user-line text-xl text-gray-700"></i>
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 cursor-pointer"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-700`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <a
                  key={link.path}
                  href={link.path}
                  className="text-gray-700 hover:text-teal-600 font-medium transition-colors cursor-pointer"
                >
                  {link.name}
                </a>
              ))}
              <a
                href="/add-listing"
                className="px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-center cursor-pointer whitespace-nowrap"
              >
                Add a Listing
              </a>
              <a
                href={userPath}
                className="px-6 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-center cursor-pointer whitespace-nowrap flex items-center justify-center"
              >
                <i className="ri-user-line mr-2"></i>
                {user ? 'My Account' : 'Sign In / Sign Up'}
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
